import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

import { ReplaySubject, Subject, Subscription, takeUntil } from "rxjs";
import { MatTableDataSource } from "@angular/material/table";
import {
  OPD_CONST,
} from "../../properties/opd-static-properties";
import {
  IERDashboard,
  dischargePayloadObject,
  printObject,
  statusPayloadObject,
} from "../../interface/IerRegistration";
import { MatDrawer } from "@angular/material/sidenav";
import { CookieService } from "ngx-cookie-service";
import {
  ER_REPORT_TYPE,
  opdEnvironment,
} from "../../properties/opd-field-properties";
import { EmergencySearchModel } from "../../models/MemergencyModel";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { DatePipe } from "@angular/common";
import { DocumentuploadComponent } from "../../shared/documentupload/documentupload.component";
import { PatientNotesDialogComponent } from "../patient-notes-dialog/patient-notes-dialog.component";
import { UpdatestatusComponent } from "../../shared/updatestatus/updatestatus.component";
import { PhysicalLocationDialogComponent } from "../../shared/physical-location-dialog/physical-location-dialog.component";
import { AccountDetailsDialogComponent } from "../../shared/account-details-dialog/account-details-dialog.component";
import {
  ERRegistration,
  ERRegistrationStatus,
  ERStatusColor,
} from "../../enums/encounter-status.enum";
import { ConfirmRemarksComponent } from "../patient-appointment/confirm-remarks/confirm-remarks.component";
import { APPLICATIONSERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/application-service";
import { UICONFIGSERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/uiconfig-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { BarcodeScannerComponent } from "projects/lib/medcare-core-lib/src/lib/core/barcode-scanner/barcode-scanner.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { ConfirmRemarkComponent } from "projects/lib/medcare-core-lib/src/lib/core/remark-dialog/remark-dialog.component";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
@Component({
  selector: "app-emergency-registration-list",
  templateUrl: "./emergency-registration-list.component.html",
  styleUrls: ["./emergency-registration-list.component.scss"],
  providers: [DatePipe],
})
export class EmergencyRegistrationListComponent implements OnInit, OnDestroy {
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  displayedColumns: string[] = OPD_CONST.displayedDashboardColumn;
  dataSource = new MatTableDataSource<IERDashboard>();
  admissionList: IERDashboard[] = [];
  admissionListCompleteData: IERDashboard[] = [];
  statusPayload: statusPayloadObject;
  dischagrPayload: dischargePayloadObject;
  printPayload: printObject;
  public totalDataLength: number;
  public pageSize: number = 15;
  public pageIndex: number = 0;
  offsetData: number = 0;
  public paginatorOptions: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  admittedCount: number = 0;
  acceptedCount: number = 0;
  arrivedCount: number = 0;
  admissionSort: string;
  reportName: string = "";
  selectedRow: any;
  selectedRowNo: number = -1;
  clinicalDischarge: boolean = true;
  cancelDischarge: boolean = true;
  finalDischarge: boolean = true;
  userRightList: any = [];
  userName: string;
  userAutho: any;
  isCancelSplRight: boolean = false;
  dischargeCount: number = 0;
  BarCode: string;
  totalAdmission: number;
  data: any;
  account: [] = [];
  phyLocation: [] = [];
  previousInternalNotes: any[] = [];
  uName: string;
  userId: any;

  @ViewChild("drawer") drawer: MatDrawer;
  internalList: any = [];
  id: number = 0;
  dateTime: [] = [];
  langaugeValue:string="";
  constructor(
    public translate: TranslateService,
    public dialog: MatDialog,
    private searchService: SearchService,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    private patientService: PatientService,
    public authService: AuthService,
    public cookieService: CookieService,
    private env: EnvoirnmentService,
    private generalurlservice: GeneralUrlService,
    private thConvertService:thEnConverterService,
    public datePipe: DatePipe,
  ) {}

  private subscriptionList = new Subscription();
  public environment: any = opdEnvironment;
  search: EmergencySearchModel = new EmergencySearchModel();
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);

  /**
   *load method
   *
   * @memberof AdmissionDashboardComponent
   */
  ngOnInit() {
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.search.identificationType = "";
    this.search.identificationID = "";
    (this.search.MRN = ""),
      (this.search.Bed = ""),
      (this.search.patientName = ""),
      (this.search.status = ""),
      (this.search.admissionNumber = ""),
      (this.search.department = ""),
      (this.search.doctor = ""),
      (this.search.ward = ""),
      this.getSearchFilter();
    this.admissionSort = ERRegistrationStatus.admitted;
    this.getUserInfo();
    this.langaugeValue=localStorage.getItem("lan");
    this.langService.changeFooterLaber().then((val) => {
      if(this.paginator){
      this.paginator._intl.itemsPerPageLabel = val;
      }
    });
    this.getCurrentAdmissionSummary();
  }
 
  /**
   *destroy method
   *
   * @memberof AdmissionDashboardComponent
   */
  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.subscriptionList.unsubscribe();
  }

  /**
   *get user right details
   *
   * @memberof PatientEncounterListComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      this.userName = value.email;
      this.userAutho = value.autho;
      this.uName = value.name;
      this.userId = value.userId;
      this.getAdmissions();
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightCancelAdmission)
            this.isCancelSplRight = true;
        });
      }
    });
  }

  /**
   * Search filter
   */
  public getSearchFilter() {
    this.baseservice.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.baseservice
      .getResource(UICONFIGSERVICE.ADMISSION_DASHBOARD)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data[0].uiConfig != null) {
          const searchList = [];
          data[0].uiConfig.forEach((element) => {
            const controlList = [];
            element.controls.forEach((control) => {
              controlList.push({
                type: control.type,
                placeholder: opdEnvironment.placeholder[control.placeholder],
                value: "",
                column: control.column,
                name: control.name,
                url: control.url ? control.url : "",
                selectType: "",
              });
            });
            searchList.push({ controls: controlList });
          });
          this.searchService.setSearch(searchList);
        }
      });
    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        this.search.MRN = result.mrn;
        this.search.patientName = result.name;
        this.search.identificationType = result.idType
          ? result.idType.code
          : "";
        this.search.identificationID = result.idNumber;
        if (result.daterange && result.daterange) {
          if (result.daterange.startDate && result.daterange.endDate) {
            this.search.startDate = result.daterange.startDate.$d
              ? result.daterange.startDate.$d
              : "";
            this.search.endDate = result.daterange.endDate.$d
              ? result.daterange.endDate.$d
              : "";
          } else {
            this.search.startDate = result.fromDate;
            this.search.endDate = result.toDate;
          }
        }

        if (result.start && result.end) {
          if (result.start && result.end) {
            this.search.fromDate = result.start ? result.start : "";
            this.search.disToDate = result.end ? result.end : "";

            var today = this.epochConverter(this.search.fromDate);
            var sameDay = this.epochConverter(this.search.disToDate);
            if (today == sameDay)
              this.search.disToDate = new Date(
                new Date().setHours(23, 59, 0, 0)
              );
            else {
              const event = new Date(this.search.disToDate);
              event.setHours(23, 59, 0, 0);
              this.search.disToDate = event;
            }
          } else {
            this.search.fromDate = result.start;
            this.search.disToDate = result.end;
          }
        }

        this.search.department =
          result.speciality && result.speciality.desc
            ? result.speciality.desc
            : "";
        this.search.doctor =
          result.doctor && result.doctor.desc ? result.doctor.desc : "";
        this.search.ward =
          result.ward && result.ward.code ? result.ward.code : "";
        this.search.Bed =
          result.class && result.class.code ? result.class.code : "";
        this.search.admissionNumber = result.admissionNumber;
        this.search.status =
          result.Status && result.Status.code ? result.Status.code : "";
        this.getAdmissions();
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        this.search = new EmergencySearchModel();
        this.search.MRN = quickSearch;
        this.getAdmissions();
      }
    );
    this.subscriptionList.add(quickSearch);
  }

  /**
   * get admission summary details
   */
  getAdmissionSummary() {
    this.totalAdmission = 0;
    this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.baseservice
      .getResource(OPD_API_URL.GET_ER_SUMMARY+"&isCurrentPatient=false&isCancelAdmission=false")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.totalAdmission = res.totalAdmission;
      });
  }
  getCurrentAdmissionSummary() {
    this.totalAdmission = 0;
    this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.baseservice
      .getResource(OPD_API_URL.GET_ER_SUMMARY+"&isCurrentPatient=true&isCancelAdmission=false")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.totalAdmission = res.totalAdmission;
      });
  }
  getCancelAdmissionSummary() {
    this.totalAdmission = 0;
    this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.baseservice
      .getResource(OPD_API_URL.GET_ER_SUMMARY+"&isCurrentPatient=false&isCancelAdmission=true")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.totalAdmission = res.totalAdmission;
      });
  }

  /**
   *
   *
   * @param {*} $event
   * @memberof AdmissionDashboardComponent
   */
  public admissionSortMethod($event) {
    this.search = {} as EmergencySearchModel;

    if ($event.value == ERRegistrationStatus.cancelled) {
      this.displayedColumns = OPD_CONST.displayDashboardColumns;
      this.admissionList = this.admissionListCompleteData.filter(
        (x) => x.depositStatus == ERRegistrationStatus.cancelled
      );
      this.dataSource = new MatTableDataSource<IERDashboard>(
        this.admissionList
      );
      this.getAdmissions();
      this.getCancelAdmissionSummary();
    } else if ($event.value == ERRegistrationStatus.admitted) {
      this.displayedColumns = OPD_CONST.displayedDashboardColumn;
      this.admissionList = this.admissionListCompleteData.filter(
        (x) =>
          x.depositStatus != ERRegistrationStatus.cancelled &&
          x.depositStatus != ERRegistrationStatus.FINALDISCHARGED &&
          x.depositStatus != ERRegistrationStatus.checkout 
      );
      this.dataSource = new MatTableDataSource<IERDashboard>(
        this.admissionList
      );
      this.getAdmissions();
      this.getCurrentAdmissionSummary();
    } else {
      this.displayedColumns = OPD_CONST.displayedDashboardColumns;
      this.admissionList = this.admissionListCompleteData;
      this.dataSource = new MatTableDataSource<IERDashboard>(
        this.admissionList
      );
      this.getAdmissions();
      this.getAdmissionSummary();
    }
  }

  /**
   *Cancel method
   *
   * @param {*} element
   * @memberof AdmissionDashboardComponent
   */
  cancelAdmission() {
    if (this.getPatient()) {
      let payload = {
        visitNo: this.data.admissionNo,
      };
      this.baseservice.setResourceURL(MICROSERVICES.BILLING_SERVICE);
      this.baseservice
        .postResource(OPD_API_URL.OPEN_CHARGES, payload)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.cancelAdmissionPost(res.openCharge);
        });
    }
  }

  cancelAdmissionPost(res: boolean) {
    const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
      width: "300px",
      height: "auto",
      data: { dialogName: "Cancel Admission",
        pageName:"PatientEncounterList" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result.action=='yes') {
          let patchRequestData = {
            status: OPD_CONST.businessStatusList.CANCELLED,
            isConvertToOP: result.isConvertToOP,
            reason: [
              {
                system: "EN",
                code: result.reason.code,
                display: result.reason.desc,
              },
            ],
            remarks: result.remark ? result.remark : "",
          };
          this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.baseservice
            .putResource(
              OPD_API_URL.ADMISSION_UPDATE_STATUS + this.data.admissionId,
              patchRequestData
            )
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(() => {
              this.snackBar.open(
                this.langService.get("adt.admissionCancelled"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 3000,
                }
              );
              this.getAdmissions();
            });
        }
      })
    );
  }
  /**
   *Upload document
   *
   * @memberof PatientAdmisssionListComponent
   */
  uploadDocument() {
    if (this.getPatient()) {
      this.dialog.open(DocumentuploadComponent, {
        height: "350px",
        width: "1000px",
        data: {
          MRN: this.selectedRow.mrn,
          EncounterNumber: this.selectedRow.admissionNo,
        },
      });
    }
  }

  /**
   * add internal notes
   *
   * @memberof PatientAdmisssionListComponent
   */
  addInternalNotes() {
    if (this.getPatient()) {
      this.previousInternalNotes.sort((a, b) => b.addedOn - a.addedOn);

      this.previousInternalNotes = this.selectedRow.element.encounterNote
        ? this.selectedRow.element.encounterNote
        : [];
      const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
        height: "350px",
        width: "1000px",
        data: {
          listNotes: this.previousInternalNotes,
          name: "Emergency List",
          encounterno: this.selectedRow.element.encounterNumber,
        encounterId:this.selectedRow.element.id,
          isPrint:true
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe(() => {
          this.getAdmissions();
          this.previousInternalNotes = [];
        })
      );
    }
  }

  /**
   * To get admission
   * @param size
   * @param pageNo
   */
  getAdmissions() {
    this.admittedCount = 0;
    this.totalDataLength = 0;
    this.acceptedCount = 0;
    this.arrivedCount = 0;
    this.admissionList = [];
    this.admissionListCompleteData = [];
    let mrn = this.search.MRN ? this.search.MRN : "";
    let admissionNumber = this.search.admissionNumber
      ? this.search.admissionNumber
      : "";
    let frDate = this.search.startDate
      ? this.epochConverter(this.search.startDate)
      : "";
    let toDate = this.search.endDate
      ? this.epochConverter(this.search.endDate)
      : "";
    let dischargeFrDate = this.search.fromDate
      ? this.epochConverter(this.search.fromDate)
      : "";
    let dischargeToDate = this.search.disToDate
      ? this.epochConverter(this.search.disToDate)
      : "";

    let bed = this.search.Bed ? this.search.Bed : "";
    let ward = this.search.ward ? this.search.ward : "";
    let doc = this.search.doctor ? this.search.doctor : "";
    let dept = this.search.department ? this.search.department : "";
    let name = this.search.patientName ? this.search.patientName : "";
    let status = this.search.status ? this.search.status : "";
    let idType = this.search.identificationType
      ? this.search.identificationType
      : "";
    let idNumber = this.search.identificationID
      ? this.search.identificationID
      : "";

    let reqPayload =
      "?identificationId=" +
      idNumber +
      "&identificationType=" +
      idType +
      "&frDate=" +
      frDate +
      "&toDate=" +
      toDate +
      "&mrn=" +
      mrn +
      "&encounterNumber=" +
      admissionNumber +
      "&id=&bedCategory=" +
      bed +
      "&ward=" +
      ward +
      "&offset=" +
      this.offsetData +
      "&size=" +
      this.pageSize +
      "&doctorName=" +
      doc +
      "&departmentName=" +
      dept +
      "&name=" +
      name +
      "&businessStatus=" +
      status +
      "&dischargeFrDate=" +
      dischargeFrDate +
      "&dischargeToDate=" +
      dischargeToDate +
      "&visitType=ER&includedPatientData=false";
    if (this.admissionSort === ERRegistrationStatus.admitted) {
      reqPayload += "&isAdmitted=true";
    } else if (this.admissionSort === ERRegistrationStatus.cancelled) {
      reqPayload += "&isCancel=true";
    }
    this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.baseservice
      .getResource(APPLICATIONSERVICE.EXTENDED_ENCOUNTER_FILTER + reqPayload)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        if (res && res.response.length > 0 && res.response) {
          this.totalDataLength = res.totalRecords;
          res.response.forEach((element) => {
            try {
              if (element.businessStatus == ERRegistrationStatus.arrived)
                this.admittedCount += 1;
              var encounterDate = element.createdDate;
              var encounterDate_d = new Date(0);
              var todayDate = this.epochConverter(
                new Date(new Date().setHours(0, 0, 0, 0))
              );
              encounterDate_d.setUTCSeconds(encounterDate);
              let patientName: string = "-";
              let patientAge = "";
              let patientId = "";
              let isVip = false;
              let gender = "";
              let dobFormatted="";
              let genderv = "";
              let todayAdmissionData = false;
              if (
                !element.motherDetails &&
                element.businessStatus == ERRegistrationStatus.arrived
              ) {
                if (todayDate > encounterDate) todayAdmissionData = true;
              }

              if (element.patientDetails) {
                let patient = element.patientDetails;
                patientName =
                  element.patient
                    ? element.patient[0].name[0]?element.patient[0].name[0].text:"-"
                    : patient.patientName?patient.patientName:"-";
                    isVip = patient.isVip,
                patientId = patient.id;
                if (element.patient) {
                  let age = this.patientService.calculateAge(
                    new Date(element.patient[0].birthDate)
                  );
                  patientAge = age.years;
                }else if(element.patientDetails){
                  let age = this.patientService.calculateAge(
                    new Date(element.patientDetails.birthDate)
                  );
                  patientAge = age.years;
                }
                dobFormatted = element.patientDetails.birthDate
                  ? (this.langaugeValue == Langauge.TH
                    ? this.thConvertService.convertThaiDateString(element.patientDetails.birthDate)
                    : this.datePipe.transform(element.patientDetails.birthDate, "yyyy-MM-dd"))
                  : null;
                if (patient.gender) {
                  gender = element.patientDetails.gender.display
                    .toString()
                    .toUpperCase();
                  genderv = gender == "MALE" ? "M" : "F";
                    
                }
              }
              const encounter: IERDashboard = {
                admissionId: element.id,
                Color:
                  todayAdmissionData == true
                    ? "black"
                    : this.getStatusColor(
                        element.businessStatus,
                        element.motherDetails
                      ),
                admissionNo: element.encounterNumber,
                mrn: element.mrn,
                // doa: encounterDate_d,
                doa : this.langaugeValue== Langauge.TH?this.thConvertService.convertToThaiDate(encounterDate) : this.datePipe.transform(encounterDate_d, 'dd-MM-yyyy'),
                PatientId: patientId,
                patientName: patientName,
                isVip : isVip,
                patientImage: this.getGenderValue(
                  gender,
                  element.motherDetails
                ),
                PatientGender: gender + " / " + patientAge,
                // PatientAge: patientAge,
                PatientAge: this.generalurlservice.calculateAge(element.patientDetails.birthDate),
                age : this.generalurlservice.convertDateFormat(dobFormatted)+ genderv,
                time :this.generalurlservice.formatDateWithRelativeTime(encounterDate_d),
                Visittype:element.encounterType?element.encounterType.display:"",
                VisitType: "ER",
                los:element.lengthOfStay,
                admittingDoc: element.doctor ? element.doctor.display : "",
                cancelDate: element.cancelDetail
                  ? element.cancelDetail.cancelDoneOn
                  : "-",
                dischargeDate: element.dischargeDate
                  ? element.dischargeDate
                  : "-",

                admittingDept: element.department
                  ? element.department.display
                  : "",
                ward: element.bedComponent
                  ? element.bedComponent.ward
                    ? element.bedComponent.ward.display
                    : "-"
                  : "-",
                bed: element.bedComponent
                  ? element.bedComponent.bed
                    ? element.bedComponent.bed.display
                    : "-"
                  : "-",
                bedCategory: element.bedComponent
                  ? element.bedComponent.bedCategory
                    ? element.bedComponent.bedCategory.display
                    : "-"
                  : "-",
                  Clinic:
                  element.clinic && element.clinic.display
                    ? element.clinic.display
                    : "-",
                depositStatus: element.businessStatus,
                lengthOfStay: element.lengthOfStay,
                glStatus: this.getGlStatusColor(element.glStatus),
                status: this.getstatusColor(element.businessStatus),
                element: element,
              };
              this.admissionListCompleteData.push(encounter);
              this.admissionList = this.admissionListCompleteData;
            } catch (ex) {
              console.error(ex);
            }
          });
        }
        this.dataSource = new MatTableDataSource<IERDashboard>(
          this.admissionList
        );
      });
  }

  /**
   * get status color
   * @param status
   * @returns
   */
  getStatusColor(status: string, babyStatus: string): string {
    if (babyStatus) {
      return "orange";
    } else {
      switch (status) {
        case ERRegistrationStatus.admitted:
          return ERStatusColor.admitted;
        case ERRegistrationStatus.cancelled:
          return ERStatusColor.canceled;
        case ERRegistrationStatus.deschargeInitiated:
          return ERStatusColor.deschargeinitiated;
        case ERRegistrationStatus.checkout:
          return ERStatusColor.checkout;
        case ERRegistrationStatus.readyForBilling:
          return ERStatusColor.readyBilling;
        default:
          return ERStatusColor.default;
      }
    }
  }

  /**
   * get Gender Value and its mat-icon
   */
  getGenderValue(value: string, babyStatus: string): string {
    if (babyStatus) {
      return "baby.png";
    }
    switch (value) {
      case "MALE":
        return "male-blue.png";
      case "FEMALE":
        return "female-pink.png";
      default:
        return "male-blue.png";
    }
  }

  /**
   *
   * @param status according to GL status
   * @returns
   */
  getGlStatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case ERRegistration.received:
        style.text = ERRegistration.received;
        style.backgroundColor = ERStatusColor.received;
        break;
      case ERRegistration.inProgress:
        style.text = ERRegistration.inProgress;
        style.backgroundColor = ERStatusColor.inProgress;
        break;
      case ERRegistration.completed:
        style.text = ERRegistration.completed;
        style.backgroundColor = ERStatusColor.completed;
        break;
      case ERRegistration.others:
        style.text = ERRegistration.others;
        style.backgroundColor = ERStatusColor.others;
        break;
      case ERRegistration.pendingGl:
        style.text = ERRegistration.pending;
        style.backgroundColor = ERStatusColor.pendingGl;
        break;
      case ERRegistration.approvalGl:
        style.text = ERRegistration.approved;
        style.backgroundColor = ERStatusColor.approvalGl;
        break;
      case ERRegistration.declinedGl:
        style.text = ERRegistration.declined;
        style.backgroundColor = ERStatusColor.declinedGl;
        break;
        case ERRegistration.close:
        style.text = ERRegistration.close;
        style.backgroundColor = ERStatusColor.close;
        break;
      case ERRegistration.na:
        style.text = ERRegistration.na;
        style.backgroundColor = ERStatusColor.na;
        break;
      default:
        break;
    }
    return style;
  }

  /**
   *
   * @param status according to status
   * @returns
   */
  getstatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case ERRegistrationStatus.requested:
        style.text = ERRegistrationStatus.requested;
        style.backgroundColor = ERStatusColor.requested;
        break;
      case ERRegistrationStatus.rejected:
        style.text = ERRegistrationStatus.rejected;
        style.backgroundColor = ERStatusColor.rejected;
        break;
      case ERRegistrationStatus.acknowledged:
        style.text = ERRegistrationStatus.acknowledged;
        style.backgroundColor = ERStatusColor.acknowledged;
        break;
      case ERRegistrationStatus.arrived:
        style.text = ERRegistrationStatus.arrived;
        style.backgroundColor = ERStatusColor.arrived;
        break;
      case ERRegistrationStatus.cancelled:
        style.text = ERRegistrationStatus.cancelled;
        style.backgroundColor = ERStatusColor.cancelled;
        break;
      case ERRegistrationStatus.deschargeInitiated:
        style.text = ERRegistrationStatus.deschargeInitiated;
        style.backgroundColor = ERStatusColor.deschargeInitiated;
        break;
      case ERRegistrationStatus.readyForBilling:
        style.text = ERRegistrationStatus.readyForBilling;
        style.backgroundColor = ERStatusColor.readyForBilling;
        break;
      case ERRegistrationStatus.billingCompleted:
        style.text = ERRegistrationStatus.billingCompleted;
        style.backgroundColor = ERStatusColor.billingCompleted;
        break;
      case ERRegistrationStatus.discharge:
        style.text = ERRegistrationStatus.discharge;
        style.backgroundColor = ERStatusColor.discharge;
        break;
      case ERRegistrationStatus.convertToOp:
        style.text = ERRegistrationStatus.convertToOp;
        style.backgroundColor = ERStatusColor.convertToOp;
        break;
        case ERRegistrationStatus.convertToIp:
          style.text = ERRegistrationStatus.convertToIp;
          style.backgroundColor = ERStatusColor.convertToIp;
          break;
      case ERRegistrationStatus.close:
        style.text = ERRegistrationStatus.close;
        style.backgroundColor = ERStatusColor.close;
        break;
        case ERRegistrationStatus.checkout:
        style.text = ERRegistrationStatus.checkout;
        style.backgroundColor = ERStatusColor.checkout;
        break;
      case ERRegistrationStatus.admitted:
        style.text = ERRegistrationStatus.admitted;
        style.backgroundColor = ERStatusColor.admitted;
        break;
      default:
        break;
    }
    return style;
  }

  /**
   * To go next page
   * @param $event
   */
  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex ;
    this.offsetData = event.pageIndex * event.pageSize;
    this.getAdmissions();
  }

  /**
   * To refresh search
   */
  refreshSearch() {
    this.search.MRN = "";
    this.search.patientName = "";
    this.offsetData = 0
    this.pageSize = 15;
    this.getAdmissions();
  }

  /**
   *Report name capture
   *
   * @param {*} reportName
   * @memberof AdmissionDashboardComponent
   */
  OnMenuClick(reportName) {
    this.reportName = reportName;
  }

  /**
   *Generate Report
   *
   * @param {*} encounterId
   * @param {*} type
   * @memberof AdmissionDashboardComponent
   */
  printReport(selectedRow, reportName) {
    if (this.getPatient()) {
      this.printPayload = {
        transactionId: selectedRow.admissionId,
        type: ER_REPORT_TYPE.pdf,
        reportName: reportName,
        isReports: false,
      };
      localStorage.setItem(
        OPD_CONST.reportPayload,
        JSON.stringify(this.printPayload)
      );
      window.open(opdNavigation.REPORT_NAVIGATE);
    }
  }

  /**
   * On row selection
   * @memberof AdmissionDashboardComponent
   */
  rowSelected(row, i) {
    this.selectedRowNo = i;
    this.selectedRow = row;
  }

  /**
   * To get status text
   * @param txt
   * @returns text
   */
  getStatusTxt(txt) {
    if (txt == OPD_CONST.DISCHARGE_STATUS_ADMITTED)
      return ERRegistrationStatus.admitted;

    if (txt == OPD_CONST.DISCHARGE_STATUS_CLINICALDISCHARGED)
      return ERRegistrationStatus.clinicalDischarge;

    if (txt == OPD_CONST.DISCHARGE_STATUS_FINALDISCHARGED)
      return ERRegistrationStatus.finalDischarge;

    if (txt == OPD_CONST.DISCHARGE_STATUS_CANCELLED)
      return ERRegistrationStatus.cancelled;
  }

  /**
   * Select Patient List
   *
   * @memberof PatientAdmisssionListComponent
   */
  getPatient() {
    if ((this.data = this.selectedRow)) {
      return true;
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectpatient"),
        this.langService.get("CommonAppoinment.warning"),
        {
          duration: 1000,
        }
      );
      return false;
    }
  }

  /**
   * To generate clinical discharge payload
   * @param item
   * @returns payload
   */
  generateClinicalDischargePayload(item) {
    let releaseDate = new Date(item.formValue.dischargeDate);
    let index = item.formValue.dischargeTime.indexOf(":");
    let hours = item.formValue.dischargeTime.slice(0, index);
    let mins = item.formValue.dischargeTime.slice(
      index + 1,
      item.formValue.dischargeTime.length + 1
    );
    releaseDate.setHours(hours);
    releaseDate.setMinutes(mins);
    var deathtime = item.deathtimeValue ? item.deathtimeValue : "";
    this.dischagrPayload = {
      dischargeRemarks: item.formValue.remarks,
      dischargeType: {
        code: item.formValue.dischargeType.code,
        display: item.formValue.dischargeType.desc,
      },
      dischargeDestination: {
        code: item.formValue.dischargeDestination.code,
        display: item.formValue.dischargeDestination.desc,
      },
      dischargeDoctor: {
        code: item.formValue.dischargeDoctor,
        display: item.dischargeDoctorname,
      },
      dischargeDoneOn: Math.floor(releaseDate.getTime() / 1000),
      dischargeDoneTime: Math.floor(releaseDate.getTime() / 1000),
      dischargeInstruction: item.formValue.instructions,
      causeOfDeath: item.formValue.causeOfDeath
        ? item.formValue.causeOfDeath
        : "",
      deathDateTime: deathtime ? this.epochConverter(deathtime) : 0,
      deathDeclaredBy: item.formValue.deathDeclareDoctor
        ? {
            code: item.formValue.deathDeclareDoctor.code,
            display: item.formValue.deathDeclareDoctor.desc,
          }
        : {},
      sendToMortuary: item.formValue.sendMortury
        ? item.formValue.sendMortury
        : false,
    };

    return this.dischagrPayload;
  }

  /**
   * To status
   * @memberof AdmissionDashboardComponent
   */
  getStatus() {
    if (this.getPatient()) {
      {
        const dialogRef = this.dialog.open(UpdatestatusComponent, {
          width: "300px",
          data: {
            dischargeDoctor: this.selectedRow.admittingDoc,
          },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined) {
              let payload = this.generateStatusPayload(result);
              this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
              this.baseservice
                .postResource(OPD_API_URL.STATUS_UPDATE_DETAIL, payload)
                .subscribe((res) => {
                  this.snackBar.open(
                    this.langService.get("CommonAppoinment.success"),
                    this.langService.get("Status Updated"),
                    {
                      duration: 2000,
                    }
                  );
                  this.getAdmissions();
                });
            }
          })
        );
      }
    }
  }

  /**
   * To generate clicnical discharge cancel payload
   * @param item
   * @returns payload
   */
  generateClinicalDischargeCancelPayload(item) {
    let payload = {
      remarks: item.remark ? item.remark : "",
      reason: [
        {
          system: "EN",
          code: item.reason.code,
          display: item.reason.desc,
        },
      ],
    };
    return payload;
  }

  /**
   * To generate getstatus payload
   * @param item
   * @returns payload
   */
  generateStatusPayload(item) {
    const currentDateTime = new Date();
    this.statusPayload = {
      externalAdmissionId: this.selectedRow.element.id,
      remark: item.remark ? item.remark : "",
      status: item.status ? item.status : "",
      updatedBy: this.uName ? this.uName.toLowerCase() : "",
      updatedOn: currentDateTime ? this.epochConverter(currentDateTime) : "",
      updatedById: this.userId ? this.userId : "",
    };
    return this.statusPayload;
  }

  /**
   * To init final discharge
   * @memberof AdmissionDashboardComponent
   */
  initFinalDischarge() {
    if (this.getPatient()) {
      const dialogRef = this.dialog.open(ConfirmRemarkComponent, {
        width: "40%",
        data: {
          id: this.selectedRow.element.id,
          confirm: "cancel",
        },
      });

      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let payload = {
              remarks: result.remark ? result.remark : "",
            };
            this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
            this.baseservice
              .putResource(
                OPD_API_URL.UPDATE_ADMISSION_STATUS +
                  this.selectedRow.element.id,
                payload
              )
              .subscribe((res) => {
                if (res && res.message) {
                  let message =
                    res.message == "success"
                      ? this.langService.get("adt.finalDischargeCompleted")
                      : res.message;

                  this.snackBar.open(
                    this.langService.get("CommonAppoinment.success"),
                    message,
                    { duration: 2000 }
                  );
                }
                this.getAdmissions();
              });
          }
        })
      );
    }
  }

  /**
   *
   * @param BarCode
   */
  applyFilter(BarCode) {
    this.search.MRN = BarCode;
    this.getAdmissions();
    this.dataSource.filter = BarCode.trim().toLowerCase();
  }

  /**
   *
   *
   * @memberof AdmissionDashboardComponent
   */
  openBarcodeScanDialog() {
    const dialogRef = this.dialog.open(BarcodeScannerComponent, {
      width: "650px",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.applyFilter(result);
        }
      })
    );
  }

  /**
   * view bill in different tab
   */
  viewBill(mrn) {
    if (this.getPatient()) {
      this.cookieService.set("IsLoggedin", "true", 1, "/");
      this.cookieService.set("MRN", mrn , 1, "/");
      this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
      this.cookieService.set("USER_NAME", btoa(this.userName), 1, "/");
      window.open(this.env.medcareUrl+"/billing" + "/#/billing/bill/opbill");
    }
  }

  /**
   * get Physical Location details Method
   */
  getPhysicalLocationDetails() {
    if (this.getPatient()) {
      const dialogRef = this.dialog.open(PhysicalLocationDialogComponent, {
        width: "370px",
        height: "230px",
        data: {
          id: this.selectedRow.element.id,
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.phyLocation = res;
          }
        })
      );
    }
  }

  /**
   * get Account Details Method
   */
  getAccountDetails() {
    if (this.getPatient()) {
      const dialogRef = this.dialog.open(AccountDetailsDialogComponent, {
        width: "1000px",
        height: "220px",
        data: {
          id: this.selectedRow.element.id,
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            this.account = res;
          }
        })
      );
    }
  }

  /**
   * deposit in different tab
   */
  getDepositDetails() {
    if (this.getPatient()) {
      this.cookieService.set("IsLoggedin", "true", 1, "/");
      this.cookieService.set("MRN", this.selectedRow.mrn, 1 , "/");
      this.cookieService.set("accessToken", btoa(this.userAutho), 1, "/");
      this.cookieService.set("USER_NAME", btoa(this.userName), 1, "/");
      window.open(this.env.medcareUrl +"/billing"+ "/#/billing/deposit/deposit");
    }
  }

  /**
   *
   */
  viewTimeLine() {
    if (this.getPatient()) {
      this.drawer.toggle();
      this.data = this.selectedRow;
      let payload = "visitId=" + this.data.admissionId;
      this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.subscriptionList.add(
        this.baseservice
          .getResource(OPD_API_URL.GET_PATIENT_TIME_LINE + payload)
          .subscribe((res) => {
            let list = res;
            let listnew = [];
            list.forEach((element) => {
              let obj = {
                status: element.status,
                createdBy: element.createdBy,
                time: this.epochToDateConverter(element.createdOn),
              };
              listnew.push(obj);
            });
            this.internalList = listnew;
          })
      );
    }
  }

  /**
   *converter Method
   *
   * @param {*} epoch
   * @return {*}
   * @memberof AdmissionTimeLineViewComponent
   */
  epochToDateConverter(epoch: number): string {
    try {
      const epochString = epoch.toString().replace(/\D/g, "");
      const length = epochString.length;
      if (length == 10) {
        var d = new Date(0);
        d.setUTCSeconds(epoch);
      } else {
        var d = new Date(0);
        d.setUTCMilliseconds(epoch);
      }
      const datePipe = new DatePipe("en-US");
      const formattedDate = datePipe.transform(
        d,
        "EEE, LLLL dd, yyyy , hh:mm a"
      );
      return formattedDate;
    } catch (ex) {
      return "";
    }
  }
  epochConverter(strDate) {
    if (strDate) {
      const datum = Date.parse(strDate);
      const epoch = datum / 1000;
      return epoch;
    } else return "";
  }
}
